import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    this.onClick = this.onClick.bind(this);
    this.onKeydown = this.onKeydown.bind(this);
    this.element.addEventListener("click", this.onClick);

    this.element.querySelectorAll("figure.attachment--preview img").forEach((img) => {
      img.style.cursor = "zoom-in";
    });
  }

  disconnect() {
    this.element.removeEventListener("click", this.onClick);
    this.close();
  }

  onClick(event) {
    const figure = event.target.closest("figure.attachment--preview");
    if (!figure) return;
    const img = figure.querySelector("img");
    if (!img || !img.src) return;
    event.preventDefault();

    const images = Array.from(this.element.querySelectorAll("figure.attachment--preview img"));
    const index = images.indexOf(img);
    this.open(images, index === -1 ? 0 : index);
  }

  onKeydown(event) {
    if (!this.overlay) return;
    if (event.key === "Escape") {
      this.close();
    } else if (event.key === "ArrowLeft") {
      this.show(this.currentIndex - 1);
    } else if (event.key === "ArrowRight") {
      this.show(this.currentIndex + 1);
    }
  }

  open(images, startIndex) {
    this.close();

    this.images = images;
    this.currentIndex = startIndex;

    const overlay = document.createElement("div");
    overlay.className = "bp-image-lightbox";
    overlay.setAttribute("role", "dialog");
    overlay.setAttribute("aria-modal", "true");

    const closeButton = this.buildButton("bp-image-lightbox-close", "Close", "&times;");

    const prevButton = this.buildButton("bp-image-lightbox-prev", "Previous image", "&#8249;");
    prevButton.addEventListener("click", (event) => {
      event.stopPropagation();
      this.show(this.currentIndex - 1);
    });

    const nextButton = this.buildButton("bp-image-lightbox-next", "Next image", "&#8250;");
    nextButton.addEventListener("click", (event) => {
      event.stopPropagation();
      this.show(this.currentIndex + 1);
    });

    const image = document.createElement("img");
    image.className = "bp-image-lightbox-image";

    const counter = document.createElement("div");
    counter.className = "bp-image-lightbox-counter";

    overlay.appendChild(closeButton);
    overlay.appendChild(prevButton);
    overlay.appendChild(image);
    overlay.appendChild(nextButton);
    overlay.appendChild(counter);

    overlay.addEventListener("click", (event) => {
      if (event.target === overlay || event.target === closeButton) {
        this.close();
      }
    });

    document.body.appendChild(overlay);
    document.body.style.overflow = "hidden";

    this.overlay = overlay;
    this.imageElement = image;
    this.counterElement = counter;
    this.prevButton = prevButton;
    this.nextButton = nextButton;

    document.addEventListener("keydown", this.onKeydown);
    this.render();
  }

  buildButton(className, label, glyph) {
    const button = document.createElement("button");
    button.type = "button";
    button.className = className;
    button.setAttribute("aria-label", label);
    button.innerHTML = glyph;
    return button;
  }

  show(index) {
    if (!this.images || this.images.length === 0) return;
    const total = this.images.length;
    this.currentIndex = ((index % total) + total) % total;
    this.render();
  }

  render() {
    const img = this.images[this.currentIndex];
    if (!img) return;
    this.imageElement.src = img.src;
    this.imageElement.alt = img.alt || "";

    const multiple = this.images.length > 1;
    this.prevButton.style.display = multiple ? "" : "none";
    this.nextButton.style.display = multiple ? "" : "none";
    this.counterElement.style.display = multiple ? "" : "none";
    this.counterElement.textContent = `${this.currentIndex + 1} / ${this.images.length}`;
  }

  close() {
    if (this.overlay) {
      this.overlay.remove();
      this.overlay = null;
      document.body.style.overflow = "";
    }
    document.removeEventListener("keydown", this.onKeydown);
    this.images = null;
    this.currentIndex = 0;
    this.imageElement = null;
    this.counterElement = null;
    this.prevButton = null;
    this.nextButton = null;
  }
}
